export default "__VITE_ASSET__CyB47CKi__"